import { useState } from 'react';
import { Alert, Button, PasswordInput, Stack, TextInput } from '@mantine/core';
import { useForm } from '@mantine/form';
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { errorMessage } from '@/api/http';
import { useAuth } from '@/auth/context';
import { AuthCard } from './AuthCard';

export function LoginPage() {
  const { status, login, expired } = useAuth();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const form = useForm({
    initialValues: { email: '', password: '' },
    validate: {
      email: (v) => (/^\S+@\S+$/.test(v) ? null : 'Enter your work email address.'),
      password: (v) => (v ? null : 'Enter your password.'),
    },
  });
  const next = params.get('next') || '/programmes';

  if (status === 'signedIn') return <Navigate to={next} replace />;

  const submit = form.onSubmit(async (v) => {
    setError(null);
    try {
      await login(v.email.trim(), v.password);
      navigate(next, { replace: true });
    } catch (e) {
      setError(errorMessage(e));
    }
  });

  return (
    <AuthCard title="Sign in" subtitle="For the Playbox editorial team.">
      <form onSubmit={submit} noValidate>
        <Stack>
          {expired && !error && (
            <Alert color="sky" variant="light">
              Your session ended. Sign in again to carry on.
            </Alert>
          )}
          {error && (
            <Alert color="coral" variant="light" role="alert">
              {error}
            </Alert>
          )}
          <TextInput
            label="Email"
            type="email"
            autoComplete="username"
            required
            {...form.getInputProps('email')}
          />
          <PasswordInput
            label="Password"
            autoComplete="current-password"
            required
            {...form.getInputProps('password')}
          />
          <Button type="submit" loading={form.submitting} fullWidth>
            Sign in
          </Button>
        </Stack>
      </form>
    </AuthCard>
  );
}
